import "./list.css"
import React, { useEffect, useState } from 'react';
import { COUNTRY_CODES, Country, CountryService } from "../../services/Country";
import { Button, Popconfirm, Space, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { EditOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { USER_ROLES, getCurrentUser } from "../../services/User";
import ReactCountryFlag from "react-country-flag"

function CountryList() {

    const user = getCurrentUser();
    const navigate = useNavigate();
    const [countries, setCountries] = useState<Country[]>([])

    useEffect(() => {
        const getAllCountries = async () => {
            const { data } = await CountryService.getAll();
            setCountries(data)
        }

        getAllCountries()

    }, [])

    const addCountry = () => {
        navigate(`/admin/add-country`)
    };

    const deleteCountry = async (id: string) => {
        await CountryService.delete(id!);
        let index = countries.findIndex((c: Country) => c._id === id);
        let arr = [...countries]
        arr.splice(index, 1);
        setCountries(arr)
        message.success("Successfully deleted!")
    }


    return (
        <div>
            {user.role === USER_ROLES.ADMIN && <div className="add-button"><Button onClick={addCountry} type="primary">+ Add Country</Button></div>}
            <div className="countries-grid">
                {countries?.map(c => <div key={c.name}>
                    <div className="country-item">
                        <Link to={`/${c._id}`}>
                        {c?.isTemplate != true ?
                            <ReactCountryFlag
                                countryCode={COUNTRY_CODES[c.name as keyof typeof COUNTRY_CODES]}
                                svg
                                style={{
                                    width: '200px',
                                    height:'auto',
                                    borderRadius: '10px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    marginBottom: 16
                                }}
                            /> : (
                                <div style={{
                                    width: '200px',
                                    height:'150px',
                                    borderRadius: '10px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    marginBottom: 16,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent:'center',
                                    backgroundColor: '#006eb5',
                                    color:'white'
                                }}> 
                                    Template Document 
                                </div>
                            )}
                        </Link>
                        <Space>
                            <div>{c.name}</div>
                            {user.role === USER_ROLES.ADMIN && <>
                                {/* <Link to={`/admin/country/edit/${c._id}`}><EditOutlined /></Link> */}
                                <Popconfirm
                                    title='Delete item'
                                    description="Are you sure you want to delete this country?"
                                    onConfirm={() => deleteCountry(c._id)}
                                    cancelText="Cancel"
                                >
                                    <DeleteOutlined />
                                </Popconfirm>
                            </>}
                        </Space>
                    </div>

                </div>)}
            </div>
        </div>
    );
}

export default CountryList;